import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';

export type AdminShippingSettingsFormControls = {
  labelFetchRetries: FormControl<Nillable<number>>;
  labelsInFile: FormControl<Nillable<number>>;
  senderFirstName: FormControl<Nillable<string>>;
  senderLastName: FormControl<Nillable<string>>;
  senderEmail: FormControl<Nillable<string>>;
  senderPhonePrefix: FormControl<Nillable<string>>;
  senderPhoneNumber: FormControl<Nillable<string>>;
  senderCompany: FormControl<Nillable<string>>;
  warehouseCountryCode: FormControl<Nillable<string>>;
  warehouseCity: FormControl<Nillable<string>>;
  warehouseStreet: FormControl<Nillable<string>>;
  warehousePostCode: FormControl<Nillable<string>>;
  warehouseHouseNumber: FormControl<Nillable<string>>;
  warehouseFlatNumber: FormControl<Nillable<string>>;
};

export class AdminShippingSettingsFormData {
  public static SenderFirstNameMaxLength = 255;
  public static SenderLastNameMaxLength = 255;
  public static SenderEmailMaxLength = 255;
  public static SenderPhonePrefixMaxLength = 255;
  public static SenderPhoneNumberMaxLength = 255;
  public static SenderCompanyMaxLength = 255;
  public static WarehouseCountryCodeMaxLength = 255;
  public static WarehouseCityMaxLength = 255;
  public static WarehouseStreetMaxLength = 255;
  public static WarehousePostCodeMaxLength = 255;
  public static WarehouseHouseNumberMaxLength = 255;
  public static WarehouseFlatNumberMaxLength = 255;

  public constructor(
    private readonly data: {
      labelFetchRetries: number;
      labelsInFile: number;
      senderFirstName: string;
      senderLastName: string;
      senderEmail: string;
      senderPhonePrefix: string;
      senderPhoneNumber: string;
      senderCompany?: Nillable<string>;
      warehouseCountryCode: string;
      warehouseCity: string;
      warehouseStreet: string;
      warehousePostCode: string;
      warehouseHouseNumber: string;
      warehouseFlatNumber?: Nillable<string>;
    },
  ) {}

  public get labelFetchRetries(): number {
    return this.data.labelFetchRetries;
  }

  public get labelsInFile(): number {
    return this.data.labelsInFile;
  }

  public get senderFirstName(): string {
    return this.data.senderFirstName;
  }

  public get senderLastName(): string {
    return this.data.senderLastName;
  }

  public get senderEmail(): string {
    return this.data.senderEmail;
  }

  public get senderPhonePrefix(): string {
    return this.data.senderPhonePrefix;
  }

  public get senderPhoneNumber(): string {
    return this.data.senderPhoneNumber;
  }

  public get senderCompany(): Nillable<string> {
    return this.data.senderCompany;
  }

  public get warehouseCountryCode(): string {
    return this.data.warehouseCountryCode;
  }

  public get warehouseCity(): string {
    return this.data.warehouseCity;
  }

  public get warehouseStreet(): string {
    return this.data.warehouseStreet;
  }

  public get warehousePostCode(): string {
    return this.data.warehousePostCode;
  }

  public get warehouseHouseNumber(): string {
    return this.data.warehouseHouseNumber;
  }

  public get warehouseFlatNumber(): Nillable<string> {
    return this.data.warehouseFlatNumber;
  }
}

/* prettier-ignore */
export type AdminShippingSettingsFormGroup = FormGroup<AdminShippingSettingsFormControls>;
